import { render, staticRenderFns } from "./MemberBase.vue?vue&type=template&id=00d5d84d&scoped=true"
import script from "./MemberBase.vue?vue&type=script&lang=js"
export * from "./MemberBase.vue?vue&type=script&lang=js"
import style0 from "./MemberBase.vue?vue&type=style&index=0&id=00d5d84d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d5d84d",
  null
  
)

export default component.exports